module.exports = __webpack_public_path__ + "media/components/country-flag/static/sy-42b2fb91e4bbfdb797a303cf52074a3d.svg";